import React, { Fragment, useEffect } from 'react';
import { Container, Row, Col } from "reactstrap";
import { useLocation, useNavigate } from 'react-router-dom';
import { APPConstants } from '../../../../constants/app';
import Verified from '../../assets/verified.svg';
import '../Steps/steps.scss';

function Success() {
	const location = useLocation();
	const navigate = useNavigate();

	const solution = location.state?.solution;

	useEffect(() => {
		if (!solution) {
			navigate(APPConstants.APP_BASE_URI);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleNavigate = (e) => {
		e.preventDefault();
		navigate(e.target.getAttribute('href'));
	}

	return (
		solution &&
    	<Fragment>
	        <section id="successfull-page">
	        	<nav className="header">
	        		<h3>Project created!</h3>
	        		<span className="hamburger d-none"></span>
	        	</nav>

	        	<Container className="builde-cont">
	        	<Row>
	        		<Col xs="{size: 12}">
						<div className="cont-success">
			        		<img alt='' src={Verified}/>
			        		<h1>Congrats!</h1>
			        		<p>Your project has been successfully created</p>
							<p>The contractor has been notified and will contact you as soon as possible</p>
			        		<a className="btn-white" onClick={handleNavigate} href="/solution">Go to projects</a>
			        		<a className="btn-border-white" onClick={handleNavigate} href= {APPConstants.APP_BASE_URI}>Back home</a>
			        	</div>
	        		</Col>
	        	</Row>
	        	</Container>
	        </section>
    	</Fragment>
    );
}

export default Success;